export default {
  meta: {
    title: '门店分析',
    url: '/analysis', // 埋点用，记录所属模块
    // eventId: '80bc24d9-2783-4bb0-a311-8a3e5ceee80e',
  },
};
